export enum LegacyDateTimeFormatStringComponent {
  MonthNumberWithAnyDigits = 'M',
  MonthNumberWithTwoDigits = 'MM',
  MonthNameAbbreviation = 'MMM',
  LocalizedDayName = 'ddd',
  LocalizedNumericDate = 'L',
  LocalizedFullDateWithTime = 'LLL',
  LocalizedFullDateWithTimeAndDay = 'LLLL',
  LocalizedTime = 'LT',
  MilitaryHourWithAnyDigits = 'H',
  MeridiemHourWithAnyDigits = 'h',
  HourOfDayWithAnyDigits = 'k',
  MeridiemWithLowercase = 'a',
  MeridiemWithUppercase = 'A',
  MinutesWithAnyDigits = 'm',
  SecondsWithAnyDigits = 's',
  FractionalSecondsWithOneDecimal = 'S',
  OffsetWithColon = 'Z',
}
